<template>
	<div class="container">
		<div class="panel">
			<h2>常用地址 <span class="btn btn-add" @click="add_address">添加地址</span></h2>
			<div class="table">
				<div class="header">
					<div class="name">收货人</div>
					<div class="phone">手机号</div>
					<div class="area">所在地区</div>
					<div class="detail">详细地址</div>
					<div class="action">操作</div>
				</div>
				<div v-for="(item,index) in address_list" :key="index" class="item">
					<div class="name">{{ item.contact_person }}</div>
					<div class="phone">{{ item.contact_mobile }}</div>
					<div class="area">{{ item.province }} {{ item.city }} {{ item.zone }}</div>
					<div class="detail">{{ item.address }}</div>
					<div class="action">
						<span class="btn-plain" @click="edit_address(item.id)">修改</span>
						<span class="btn-plain" @click="del(item.id)">删除</span>
						<span class="btn-default" :class="item.is_default ? 'btn-default-yes':'btn-default-no'" @click="set_default(item)">{{ item.is_default ? '默认地址':'设为默认' }}</span>
					</div>
				</div>
			</div>
		</div>

		<popup :show.sync="is_popup_show" width="650px" height="520px" @on-close="close">
			<h2>添加收货地址</h2>
			<div class="form">
				<div class="form-group">
					<div class="form-label">收货人：</div>
					<div class="form-control">
						<input type="text" class="input" placeholder="请输入收货人" v-model="form_data.contact_person" />
					</div>
				</div>
				<div class="form-group">
					<div class="form-label">手机号：</div>
					<div class="form-control">
						<input type="text" class="input" placeholder="请输入手机号" v-model="form_data.contact_mobile" />
					</div>
				</div>
				<div class="form-group">
					<div class="form-label">所在地区：</div>
					<div class="form-control">
						<Cascader class="input1" :data="region" v-model="value"  placeholder="请选择省/市/区/街道"></Cascader>
					</div>
				</div>

				<div class="form-group">
					<div class="form-label">详细地址：</div>
					<div class="form-control">
						<textarea placeholder="请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等信息" v-model="form_data.address" />
					</div>
				</div>
				<div class="form-group">
					<div class="form-label"></div>
					<div class="form-control">
						<input type="checkbox" v-model="form_data.is_default" /> 是否默认地址
					</div>
				</div>
				<div class="btn-submit" @click="save">保存地址</div>
			</div>
		</popup>
	</div>

</template>

<script>
	import {
	Profile,
} from "@/api/index.js";
import Popup from "@/components/Popup.vue";
import region from "@/utils/region.js";
import axios from 'axios';
import { AddressList, DeleteAddress, GetAddress, SaveAddress, SetDefaultAddress } from "../../api";
	const form_data = {
		id: 0,
		contact_person: '',
		contact_mobile: '',
		province: '',
		city: '',
		zone: '',
		address: '',
		is_default: 0,
	}
	export default {
		name: 'Address',
		components: {
			Popup
		},
		data() {
			return {
				form_data: {...form_data},
				is_popup_show: false,
				value: [],
				region: region,
				address_list: [],
			};
		},
		computed: {
			avatar() {
				return this.profile.avatar || require('@/assets/images/avatar.png')
			}
		},
		watch: {
			is_popup_show(val) {
				console.log(val)
				document.body.style.overflow = val ? 'hidden' : '';
			}
		},
		mounted() {
			axios.all([
				this.getProfile(),
				this.getList()
			]).then(axios.spread(() => {

			}))
		},
		methods: {
			close() {
				this.reset()
			},
			reset() {
				this.form_data = {...form_data}
				this.value = []
			},
			save() {
				this.form_data.province = this.value[0]
				this.form_data.city = this.value[1]
				this.form_data.zone = this.value[2]
				
				// 验证必填字段
				if (!this.form_data.contact_person || this.form_data.contact_person.trim() === '') {
					this.$layer.msg('请填写收货人')
					return
				}
				if (!this.form_data.contact_mobile || this.form_data.contact_mobile.trim() === '') {
					this.$layer.msg('请填写联系电话')
					return
				}
				if (!this.form_data.province || !this.form_data.city || !this.form_data.zone) {
					this.$layer.msg('请选择省市区')
					return
				}
				
				SaveAddress(this.form_data).then(() => {
					this.$layer.msg(`保存成功`)
					this.reset()
					this.is_popup_show = false
				}).finally(() => {
					this.getList()
				})
			},
			add_address() {
				this.is_popup_show = true
				if(this.address_list.length < 1){
					this.form_data.is_default = 1;
				}
			},
			edit_address(id) {
				GetAddress({id}).then(response => {
					this.form_data = response.data
					this.value = [this.form_data.province, this.form_data.city, this.form_data.zone]
					this.is_popup_show = true
				})
			},
			del(id) {
				this.$DModal.confirm({
					content: '确认删除该条地址信息么？',
					onOK: () => {
						DeleteAddress({id}).then(() => {
							this.$layer.msg(`操作成功`)
						}).finally(() => {
							this.getList()
						})
					}
				})
			},
			set_default(address) {
				if(address.is_default) {
					return
				}
				SetDefaultAddress({id: address.id}).then(response => {
					this.$layer.msg(`操作成功`)
					this.getList()
				})
			},
			async getList() {
				return AddressList().then(response => {
					this.address_list = response.data
					return response.data
				})
			},
			async getProfile() {
				return Profile().then(response => {
					return response
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.container {
		.panel {
			margin-bottom: 10px;
			padding: 8px 30px;
			background: white;
			h2 {
				position: relative;
				color: #333333;
				padding: 24px 0;
				border-bottom: 1px solid #EBEBEB;
				font-size: 18px;
				font-weight: bold;
				.btn-add {
					position: absolute;
					top: 20px;
					right: 0;
					width: 110px;
					height: 40px;
					line-height: 40px;
					text-align: center;
					background: #FA3D5A;
					color: white;
					border-radius: 10px;
					font-size: 12px;
					cursor: pointer;
				}
			}

			.table {
				background: #FFFFFF;
				border: 1px solid #E3E3E3;
				margin-top: 20px;
				font-size: 14px;
				color: #191A1C;
				.item,
				.header {
					display: flex;

					div {
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						text-align: center;
					}

					.name {
						width: 120px;
						padding-left: 20px;
					}

					.phone {
						width: 150px;
						padding-left: 20px;
					}

					.area {
						width: 200px;
						padding-left: 20px;
					}

					.detail {
						width: 200px;
						padding-left: 20px;
					}

					.action {
						width: 180px;
						padding-left: 20px;
					}
				}

				.header {
					background: #EDEFF2;
					height: 40px;
					line-height: 40px;
				}

				.item {
					height: 80px;
					line-height: 80px;
					border-bottom: 1px solid #DDDDDD;
					&:last-child {
						border: none;
					}
					.action {
						display: flex;
						justify-content: space-around;
						align-items: center;

						.btn-plain {
							cursor: pointer;
						}

						.btn-default {
							width: 65px;
							height: 25px;
							line-height: 25px;
							border: 1px solid #696A6A;
							border-radius: 13px;
							font-size: 12px;
							cursor: pointer;
							&.btn-default-yes {
								background: rgba(250,61,90, 0.2);
								color: #FA3D5A;
								border: none;
							}
							&.btn-default-no {
								background: white;
								color: #68696A;
							}
						}
					}
				}

			}

		}

		::v-deep .popup-modal {
			display:flex;
			flex-direction:column;
			h2 {
				padding: 10px 20px;
				color: #333333;
				font-size: 18px;
				font-weight: bold;
				border-bottom: 1px solid #F0F0F0;
			}
			.form {
				padding: 10px 0;
				flex:1;
				.form-group {
					display: flex;
					flex-wrap: wrap;
					justify-content: left;
					align-items: center;
					margin-top: 20px;
					width:100%;
					.form-label {
						width: 80px;
						font-size: 14px;
						color: #696A6A;
						text-align: right;
						flex-shrink:0;
					}
					.form-control {
						position: relative;
						flex:1;
						.input {
							width: 100%;
							height: 48px;
							line-height: 48px;
							border: 1px solid #D9D9D9;
							border-radius: 5px;
							padding: 0 10px;
							outline: none;
							font-size: 14px;
							&[readonly] {
								border: none;
							}
						}
						textarea {
							width: 100%;
							height: 100px;
							border: 1px solid #D9D9D9;
							padding: 5px;
						}

					}
				}

				.btn-submit {
					margin: 40px 0 0 40px;
					width: 110px;
					height: 40px;
					line-height: 40px;
					text-align: center;
					background: #FA3D5A;
					color: white;
					border-radius: 6px;
					cursor: pointer;
				}

			}
		}
	}

	::v-deep .ivu-input {
		width: 100%;
		height: 48px;
		line-height: 48px;
		border: 1px solid #E3E3E3;
		border-radius: 10px;
		padding: 0 10px;
		outline: none;
	}
	::v-deep .ivu-cascader .ivu-select-dropdown {
		background-color: #ffffff;
	}
	::v-deep .ivu-cascader-menu {
		min-width: 130px;
		background-color: #ffffff;
	}
</style>
